// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__Is0jv","tabs":"Tabs_tabs__OjIPE","content":"Tabs_content__HC18j","hidden":"Tabs_hidden__Jy4Et"};